// extracted by mini-css-extract-plugin
export default {"quill-container":"emailNotification_quill-container__R8y8-","quill":"emailNotification_quill__hsRrQ","image-section":"emailNotification_image-section__g3nuM"};